import { ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Req } from '@nestjs/common';
import { LabellingData } from './dto/labelling.dto';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { AllLabellingResponseModel, LabellingDto, LabellingResponseModel } from '@gtpl/shared-models/production-management';
import { LabellingIdRequest } from './dto/labelling-id-request';
import { LabellingService } from './labelling.service';
import { CommonResponse } from '@gtpl/shared-models/masters';
//service

@ApiTags('Labelling')
@Controller('labelling')

export class LabellingController {
    constructor(
        private labellingService: LabellingService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ) { }
    @Post('/createLabelling')
    async createLabelling(@Body() dto: LabellingData, isUpdate: boolean = false): Promise<LabellingResponseModel> {
        try {
            return await this.labellingService.createLabelling(dto, false);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(LabellingResponseModel, error);
        }
    }
    @Post('/updateLabelling')
    async updateLabelling(@Body() dto: LabellingData, @Req() request: Request): Promise<LabellingResponseModel> {
        try {
            return await this.labellingService.createLabelling(dto, true);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(LabellingResponseModel, error);
        }
    }
    @Post('/getAllLabellings')
    async getAllLabellings(): Promise<AllLabellingResponseModel> {
        try {
            return await this.labellingService.getAllLabellings();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllLabellingResponseModel, error);
        }
    }
    @Post('/getAllActiveLabellings')
    async getAllActiveLabellings(@Req() request: Request): Promise<AllLabellingResponseModel> {
        try {
            return await this.labellingService.getAllActiveLabellings();
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllLabellingResponseModel, error);
        }
    }
    @Post('/activateOrDeactivateLabelling')
    async activateOrDeactivateLabelling(@Body() qReq: LabellingIdRequest): Promise<LabellingResponseModel> {
        try {
            return await this.labellingService.activateOrDeactivateLabelling(qReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(LabellingResponseModel, error);
        }
    }
    @Post('/createLabellingInfo')
    async createLabellingInfo(@Body() labellingInfo: LabellingData): Promise<CommonResponse> {
        try {
            return await this.labellingService.createLabellingInfo(labellingInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CommonResponse, error);
        }
    }

    @Post('/getAllLabellingSamplesForLabelId')
    async getAllLabellingSamplesForLabelId(@Body() qReq: LabellingIdRequest): Promise<LabellingResponseModel> {
        try {
            return await this.labellingService.getAllLabellingSamplesForLabelId(qReq);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(LabellingResponseModel, error);
        }
    }
}


